import React, { useContext, useState } from 'react';
import { FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import ScreenTextContext from '../../contexts/ScreenTextContext';
import { BackNextButtons } from './BackNextButtons';
import { TeamCard } from '../';

const team1Choices = [ "atomicStrikers", "hazbins", "teamIsotope", "theLabPack", "wasteChasers" ];
const team2Choices = [ "hazmatters", "spillbusters", "spontaneousCombustibles", "theBungWrenches", "velvetMoonsuits"];

const useStyles = makeStyles((theme) => ({
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    width: 'calc(100% + 10px)',
    margin: '-5px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  spacer: {
    flex: '0 0 1px',
  },
  label: {
    flex: '0 0 18%',
    minWidth: '14rem',
    padding: '5px',
    margin: 0,
    [theme.breakpoints.up('lg')]: {
      flex: '0 0 50%',
    },
    [theme.breakpoints.up('xl')]: {
      flex: '0 0 33.33%',
    },
  },
}));

export const ChooseTeams = ({changeStep, teams, setTeams}) => {
  
  const classes = useStyles();

  const [team1, setTeam1] = useState(teams[0] || "");
  const [team2, setTeam2] = useState(teams[1] || "");

  const [focusedBoxes, setFocusedBoxes] = useState(new Set([]));

  // Load screen text
  const { screenText } = useContext(ScreenTextContext);  

  if (!screenText || !screenText.setUp ) {
    return ''; // Should return error? Loading?
  }
  
  const { teams : teamScreenText } = screenText.setUp;
  const { teamNames } = screenText.global

  // Checkbox handlers
  const handleChange1 = (e) => {
    setTeam1(e.target.value);
  }

  const handleChange2 = (e) => {
    setTeam2(e.target.value);
  }

  // Focus/hover handlers
  const handleFocus = ({target:box}) => {
    const newFocusedBoxes = new Set(focusedBoxes)
    newFocusedBoxes.add(box.name)
    setFocusedBoxes(newFocusedBoxes);
  }

  const handleBlur = ({target:box}) => {
    const newFocusedBoxes = new Set(focusedBoxes)
    newFocusedBoxes.delete(box.name)
    setFocusedBoxes(newFocusedBoxes);
  }


  // Button handlers
  const handleBack = () => {
    changeStep.backward();
    setTeams([team1, team2])
  }

  const handleNext = () => {
    changeStep.forward();
    setTeams([team1, team2])
  }

  return (
    <div className="teams">

      <div className="set-up__container set-up__container--min-height set-up__container--wide teams__wrapper">

        <h1 className="teams__title h2">{teamScreenText.title}</h1>

        <fieldset className="teams__team teams__team--0">

          <legend>{teamScreenText.team} 1</legend>

          <RadioGroup 
            aria-label="team" 
            name="team" 
            value={team1} 
            onChange={handleChange1} 
            className={classes.radioGroup}
          >
            
            <div className={classes.spacer}></div>

            {team1Choices
              .sort((a,b) => teamNames[a].label < teamNames[b].label ? -1 : (teamNames[a].label > teamNames[b].label ? 1 : 0))
              .map((team, i) => (

                  <FormControlLabel 
                    key={i} 
                    value={team}
                    className={classes.label}
                    label={ <TeamCard team={team} active={team1 === team} focused={focusedBoxes.has(team)} showHover />}
                    dataname={team}
                    control={
                      <Radio 
                        name={team} 
                        className="sr-only" 
                        onFocus={handleFocus}
                        onBlur={handleBlur} 
                      />}  
                  />

              )
            )}

          </RadioGroup>
        </fieldset>
        
        <div className="teams__vs">VS</div>
          
        <fieldset className="teams__team teams__team--1">

          <legend>{teamScreenText.team} 2</legend>

          <RadioGroup aria-label="team" name="team" value={team2} onChange={handleChange2} className={classes.radioGroup}>
            
            <div className={classes.spacer}></div>

            {team2Choices
              .sort((a,b) => teamNames[a].label < teamNames[b].label ? -1 : (teamNames[a].label > teamNames[b].label ? 1 : 0))
              .map((team, i) => (

                  <FormControlLabel 
                    key={i} 
                    value={team}
                    className={classes.label}
                    dataname={team}
                    label={ <TeamCard team={team} active={team2 === team} focused={focusedBoxes.has(team)} showHover />}
                    control={
                      <Radio  
                        name={team} 
                        className="sr-only" 
                        onFocus={handleFocus}
                        onBlur={handleBlur} 
                      />
                    }  
                  />
              
                )
            )}

          </RadioGroup>
        </fieldset>

      </div>

      <BackNextButtons handleBack={handleBack} handleNext={handleNext} disableNext={!team1 || !team2} />
      
    </div>
  )
}